import styled from '@emotion/styled';
import { Button } from '@mui/material';

import { customPalette } from '../../../../../../styles/theme';

export const QuestionContainer = styled.div`
  padding: 24px;
  background-color: ${customPalette.grey[0]};
  border-radius: 8px;
  margin-bottom: 24px;
`;

export const QuestionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  h3 {
    color: ${customPalette.grey.main};
    margin: 0;
  }

  .actions {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;

export const QuestionInputWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 24px;
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: opacity 0.2s ease;

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export const SelectContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
`;

export const AnswerOptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AnswerOptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const AnswerOptionInput = styled.input<{
  $isPositive?: boolean;
  disabled?: boolean;
}>`
  flex: 1;
  padding: 8px 12px;
  border: 2px solid
    ${(props) =>
      props.disabled
        ? customPalette.grey[200]
        : props.$isPositive
          ? customPalette.positive.main
          : customPalette.negative.main};
  border-radius: 4px;
  font-size: 14px;
  color: ${(props) =>
    props.disabled
      ? customPalette.grey[400]
      : props.$isPositive
        ? customPalette.positive.main
        : customPalette.negative.main};

  &:focus {
    outline: none;
    border-color: ${(props) =>
      props.disabled
        ? customPalette.grey[200]
        : props.$isPositive
          ? customPalette.positive.main
          : customPalette.negative.main};
  }

  &::placeholder {
    color: ${(props) =>
      props.disabled
        ? customPalette.grey[300]
        : props.$isPositive
          ? customPalette.positive.main
          : customPalette.negative.main};
    opacity: ${(props) => (props.disabled ? 0.5 : 0.7)};
  }

  &:disabled {
    background-color: ${customPalette.grey[50]};
    cursor: not-allowed;
  }
`;

export const AddAnswerButton = styled(Button)`
  color: ${customPalette.blue.main};
  padding: 8px;
  border: 1px dashed ${customPalette.grey[200]};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-transform: none;
  background-color: ${customPalette.grey[0]};

  &:hover {
    background-color: ${customPalette.grey[50]};
    border-color: ${customPalette.blue.main};
  }

  svg {
    font-size: 20px;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${customPalette.grey[400]};
  transition: color 0.2s;

  &:hover {
    color: ${customPalette.negative.main};
  }

  svg {
    font-size: 18px;
  }
`;

export const HintContainer = styled.div`
  background-color: ${customPalette.grey[50]};
  padding: 16px;
  border-radius: 4px;
  border: 1px solid ${customPalette.grey[200]};
`;

export const SavedStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  .saved-text {
    color: ${customPalette.grey[400]};
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
  }
`;

export const SavedBadge = styled.span`
  color: ${customPalette.positive.main};
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border: 1px solid ${customPalette.positive.main};
  border-radius: 4px;
`;

export const EditButtonWrapper = styled.div`
  button {
    padding: 6px 12px;
    min-width: auto;
  }
`;
